import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  createCohostInvitation,
} from '../../modules/hostInvitation';
import { ReactComponent as EditIcon } from '../../assets/images/lined/new.svg';
import { ReactComponent as AdminIcon } from '../../assets/images/solid/admin.svg';
import { ReactComponent as AlertIcon } from '../../assets/images/solid/alert.svg';
import { ReactComponent as ResendIcon } from '../../assets/images/lined/rotate.svg';
import { AlertLinkOptions, AlertConfirm } from '../../utils/alerts';
import { CardInfoContainer, HostCard } from './styles';

export const Host = ({
  enabledProperties,
  organizationRole,
  currentUser,
  isMember,
  token,
  name,
  email,
  isInvitation,
  id,
  t,
  resendInviteCohost,
  history,
  isPremium,
}) => {
  const invitiationAlert = async () => {
    await AlertLinkOptions.fire({
      text: `${t('users.resendInvitationRequest')} ${email}?`,
      icon: 'info',
      iconHtml: '<svg width="78px" height="78px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Icon/illustration/email" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Group" transform="translate(3.000000, 3.000000)"><path d="M0,20.1085515 C0,31.2135651 9.00284965,40.2162162 20.1081081,40.2162162 C31.2133666,40.2162162 40.2162162,31.2135651 40.2162162,20.1085515 C40.2162162,9.00353786 31.2142533,0.00177339725 20.1089948,0.000886698627 L20.1089948,0 L0.000886718177,0 C0.000886718177,0 0,20.095251 0,20.1085515" id="Fill-12" fill="#FFEEF2" fill-rule="nonzero"></path><path d="M14.7945397,11.5717349 L36.8485938,11.5717349 L36.8485938,23.7688884 L29.4439873,29.4835811 L26.4250104,26.883893 C26.42032,26.8798251 26.4162892,26.8773031 26.4117455,26.873642 C26.074333,26.5926342 25.5970892,26.5823019 25.2469248,26.883893 L22.2060351,29.5023746 L14.7945397,23.8160755 L14.7945397,11.5717349 Z" id="Path" fill="#D8F1EC" fill-rule="nonzero"></path><g id="message" transform="translate(7.783784, 7.783784)"><path d="M35.000277,12.7472077 C35.0002086,12.6929153 34.9884417,12.6109127 34.9679865,12.5636713 C34.9141461,12.362437 34.7944932,12.1786185 34.6153902,12.0502911 L29.6013261,8.45796913 L29.6013261,4.60701806 C29.6013261,4.09652872 29.1996099,3.68249649 28.7043059,3.68249649 L22.9358609,3.68249649 L18.0277673,0.165619797 C17.7210072,-0.0544405932 17.3137496,-0.0553572177 17.0060317,0.163786548 L12.0662632,3.68249649 L6.32306234,3.68249649 C5.82762148,3.68249649 5.42604209,4.09652872 5.42604209,4.60701806 L5.42604209,8.41263147 L0.387623301,12.0016395 C0.139766044,12.1781954 0.00567820932,12.4604453 0.00143665537,12.749041 C0.00116300673,12.7544702 0,12.7596174 0,12.7652582 L0.0267491547,32.8065478 C0.0270912155,33.0517096 0.12191047,33.2867181 0.290272797,33.4598896 C0.458429887,33.6327086 0.686242382,33.7297297 0.923769403,33.7297297 C0.924248288,33.7297297 0.924590349,33.7297297 0.925000822,33.7297297 L34.1312373,33.6826998 C34.6265414,33.6819947 35.0277103,33.2674689 35.0270262,32.7569091 L35.000277,12.7472077 Z M29.6012577,10.7099745 L32.4675904,12.7630724 L29.6012577,14.8168753 L29.6012577,10.7099745 Z M17.5145393,2.04970621 L19.7933483,3.68242598 L15.2225951,3.68242598 L17.5145393,2.04970621 Z M7.22008259,5.53153964 L27.8072172,5.53153964 L27.8072172,16.102406 L20.8951262,21.0551397 L18.0769556,18.8020766 C18.0725773,18.7985512 18.0688146,18.7963654 18.064573,18.7931924 C17.7496034,18.5496524 17.3041035,18.5406976 16.9772302,18.8020766 L14.1386044,21.0714274 L7.22008259,16.1433015 L7.22008259,5.53153964 Z M5.42604209,10.6602653 L5.42604209,14.8654564 L2.47433102,12.7629314 L5.42604209,10.6602653 Z M1.79636651,14.5287027 L12.6512556,22.2604304 L1.8182584,30.9206987 L1.79636651,14.5287027 Z M3.54888082,31.8770201 L17.5271271,20.7023803 L31.4552273,31.8374642 L3.54888082,31.8770201 Z M22.3806278,22.2427325 L33.2086309,14.4841406 L33.2305228,30.9170322 L22.3806278,22.2427325 Z M24.2599895,8.99459459 C24.7657399,8.99459459 25.1756757,9.4981053 25.1756757,10.1189189 C25.1756757,10.7397325 24.7657399,11.2432432 24.2599895,11.2432432 L11.8616321,11.2432432 C11.3560214,11.2432432 10.9459459,10.7397325 10.9459459,10.1189189 C10.9459459,9.4981053 11.3560214,8.99459459 11.8616321,8.99459459 L24.2599895,8.99459459 Z M24.2599895,13.4918919 C24.7657399,13.4918919 25.1756757,13.9954026 25.1756757,14.6162162 C25.1756757,15.2370298 24.7657399,15.7405405 24.2599895,15.7405405 L11.8616321,15.7405405 C11.3560214,15.7405405 10.9459459,15.2370298 10.9459459,14.6162162 C10.9459459,13.9954026 11.3560214,13.4918919 11.8616321,13.4918919 L24.2599895,13.4918919 Z" id="Shape" fill="#0A1428" fill-rule="nonzero"></path><polygon id="Path" fill="#FFFFFF" points="1.79636651 14.5287027 12.6512556 22.2604304 1.8182584 30.9206987"></polygon><polygon id="Path" fill="#FFFFFF" points="29.6012577 10.7099745 32.4675904 12.7630724 29.6012577 14.8168753"></polygon><polygon id="Path" fill="#FFFFFF" points="17.5145393 2.04970621 19.7933483 3.68242598 15.2225951 3.68242598"></polygon><polygon id="Path" fill="#FFFFFF" points="5.42604209 10.6602653 5.42604209 14.8654564 2.47433102 12.7629314"></polygon><polygon id="Path" fill="#FFFFFF" points="3.54888082 31.8770201 17.5271271 20.7023803 31.4552273 31.8374642"></polygon><polygon id="Path" fill="#FFFFFF" points="22.3806278 22.2427325 33.2086309 14.4841406 33.2305228 30.9170322"></polygon></g></g></g></svg>',
      cancelButtonText: t('cancel'),
      confirmButtonText: t('users.sendAgain'),
    }).then(async (result) => {
      if (result.value) {
        try {
          await resendInviteCohost({
            name,
            email,
            enabledProperties,
            token,
            role: organizationRole,
          }).then(() => {
            AlertConfirm.fire({
              icon: 'success',
              text: t('users.emailSentTo') + email,
            });
          });
        } catch (err) {
          return AlertConfirm.fire({
            icon: 'error',
            text: t('users.errorInvitation'),
          });
        }
      }
      return undefined;
    });
  };

  const alertNotPremium = () => {
    AlertLinkOptions.fire({
      icon: 'warning',
      text: t('users.premiumWarning'),
      cancelButtonText: t('cancel'),
      confirmButtonText: t('updatePlan'),
    }).then(async (result) => {
      if (result.value) {
        history.push({ pathname: '/billing' });
      }
    });
  };

  return (
    <HostCard>
      <CardInfoContainer>
        <div
          className="host-header"
          id="host-link"
        >
          <div>
            <h5>{name}</h5>
            <p className="acesses">
              {t('users.getAccessTo')}
              {' '}
              {enabledProperties.length}
              {' '}
              {enabledProperties.length !== 1 ? t('properties').toLowerCase() : t('singleProperty').toLowerCase() }
            </p>
          </div>
          {isInvitation ? (
            <p className="info warning">
              <AlertIcon className="warning" />
              {t('users.awaitingConfirmation')}
            </p>
          ) : (
            <>
              {(organizationRole === 'admin' || !organizationRole) && (
              <p className="info">
                <AdminIcon />
                {t('users.adminRole')}
              </p>
              )}
            </>
          )}
        </div>

        <div className="host-body">
          {isInvitation && (
            <ResendIcon className="resend" onClick={() => (isPremium ? invitiationAlert() : alertNotPremium())} />
          )}
          {(!currentUser && !isMember) && (
            <Link
              to={{
                pathname: '/manage/host/item',
                state: {
                  enabledProperties,
                  organizationRole,
                  token,
                  name,
                  email,
                  isInvitation,
                  id,
                  isPremium,
                },
              }}
              className="edit-host"
            >
              <EditIcon />
            </Link>
          )}
        </div>
      </CardInfoContainer>
    </HostCard>
  );
};

const mapDispatchToProps = (dispatch) => ({
  resendInviteCohost: (data) => dispatch(createCohostInvitation(data)),
});

export default withTranslation()(
  withRouter(connect(null, mapDispatchToProps)(Host)),
);
